// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListModuleData } from './genericApiResponseListModuleData';
import type { GenericApiResponseListModuleMessage } from './genericApiResponseListModuleMessage';
import type { GenericApiResponseListModulePagination } from './genericApiResponseListModulePagination';
import type { GenericApiResponseListModuleError } from './genericApiResponseListModuleError';

export interface GenericApiResponseListModule {
  data?: GenericApiResponseListModuleData;
  message?: GenericApiResponseListModuleMessage;
  pagination?: GenericApiResponseListModulePagination;
  error?: GenericApiResponseListModuleError;
  statusCode?: number;
}
